export default __webpack_public_path__ + "static/media/guess.104c269c.png";